<template>
  <div>
    <div class="title_h1">Razorpay收购PoS公司Ezetap</div>
    <div class="head">
      <div class="event">投资事件</div>
      <div class="tags">
        标签：
        <div class="tagItem">#商界</div>
        <div class="tagItem">#收购</div>
      </div>
      <div class="source">来源：IT桔子</div>
      <div class="createdTime">发布时间：2022-08-13 18::00:01</div>
    </div>
    <div class="content">
      Razorpay似乎正在疯狂收购。这家专注于业务的支付网关聚合和新银行平台通过一笔一级和二级交易收购了数字支付解决方案提供商Ezetap，这是Razorpay在2022年进行的第三笔收购交易。
      根据Ezetap在新加坡的控股公司提交给监管机构的文件，Razorpay已经收购了Ezetap Mobile
      Solutions的多数股权。此次收购包括一级和二级交易，Razorpay将收购这家总部位于班加罗尔的公司80%以上的股份。
      这些文件进一步表明，Ezetap的早期投资者Helion
      Ventures在收购后仍持有该公司的少数股权。据消息人士透露，Razorpay还将在未来几周内收购Helion的股份。一位不愿透露姓名的消息人士称，这笔交易以现金和股票的形式进行，金额可能在1-1.2亿美元之间。
      成立10年的Ezetap自成立以来已经筹集了约5000万美元，其中包括2017年8月的1600万美元融资。在过去4年里，该公司成功地从Js
      Investments和Social capital等现有投资者那里筹集了小额资金。
      此外，Ezetap还打算融资约6000万美元，并委托了Unitus
      Capital进行融资，但消息人士表示，这一努力进展得并不顺利。上述消息人士补充说:“大多数纯粹的销售点(PoS)公司(不包括Pine
      Labs)都在挣扎。”
    </div>
    <div class="imgBox">
      <div class="imgTitle">资讯图集 1</div>
      <img src="" alt="" />
    </div>

    <div class="go_back">
      <div class="button" @click="clickGo">返回上级</div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {
    // 返回上级
    clickGo() {
      this.$router.go(-1)
    }
  },

  created() {},

  mounted() {}
}
</script>
<style scoped lang="less">
.title_h1 {
  color: #1a1f33;
  font-size: 24px;
  font-weight: 500;
  display: flex;
  flex-direction: row-reverse;
  margin-right: 249px;
  margin-bottom: 27px;
}
.head {
  display: flex;
  height: 32px;
  align-items: center;
  font-size: 14px;
  color: #999999;
  padding-left: 139px;
  margin-bottom: 17px;
  box-sizing: border-box;
  .event {
    box-sizing: border-box;
    padding: 6px 10px;
    background-color: rgba(255, 184, 71, 0.2);
    color: #ffb847;
    border-radius: 4px;
    margin-right: 27px;
    margin-left: 46px;
  }
  .tags {
    display: flex;
    margin-right: 100px;
  }
  .source {
    margin-right: 116px;
  }
}

.content {
  padding-left: 139px;
  padding-right: 214px;
  font-size: 14px;
  color: #1a1f33;
  line-height: 35px;
}
.imgBox {
  margin-top: 43px;
  padding-left: 139px;
  color: #333;
  font-size: 18px;
  font-weight: 500;
  .imgTitle {
    margin-bottom: 12px;
  }
}

.go_back {
  display: flex;
  justify-content: center;

  margin-top: 88px;
  color: #17757a;
  font-size: 14px;

  .button {
    padding: 8px 35px;
    border-radius: 4px;
    border: 1px solid #17757a;
    cursor: pointer;
  }
}
</style>
